export default "__VITE_ASSET__C6o3lQVO__"